export default __webpack_public_path__ + "images/2c5e3029cf91909dcae6e7dba152da53.png";